import { FormFields } from ".";

export const APPROVED_LOAN_DETAILS: FormFields = {
  fields: [
    {
      name: "rateOfInterest",
      label: "Rate of Interest (%)",
      type: "tel",
      validationRules: {
        required: false,
        pattern: {
          value: /^(?:[1-9][0-9]?(?:\.[0-9]{2})?|100(?:\.00)?)$/,
          message: "Rate of interest must be a valid number",
        },
        minLength: {
          value: 0,
          message: "Rate of interest must be a positive number",
        },
      },
    },
    {
      name: "amount",
      label: "Loan Amount",
      type: "tel",
      validationRules: {
        required: false,
        pattern: {
          value: /^(0|[1-9]\d*)$/,
          message: "Amount must be a valid positive number",
        },
        minLength: {
          value: 0,
          message: "Amount must be a positive number",
        },
        maxLength: {
          value: 7,
          message: "Amount must be at most 7 digits",
        },  
      },
    },
    {
      name: "tenureInMonths",
      label: "Tenure (in months)",
      type: "tel",
      validationRules: {
        required: false,
        minLength: {
          value: 1,
          message: "Tenure must be at least 1 month",
        },
      },
    },
    {
      name: "bureauScore",
      label: "Bureau Score",
      type: "tel",
      validationRules: {
        required: false,
      },
    },
  ],
};
